<div class="list-wrapper overflow-visible">
  @for (member of forestMembers; track $index) {
    <div class="item" (click)="onMemberClick(member)">
      <div class="left-side">
        <div class="flex flex-col justify-center items-center w-10 h-10">
          <rank-badge [rank]="$index + pageOffset"></rank-badge>
        </div>
        <app-user-avatar
          [size]="40"
          [avatarUrl]="getAvatarUrl(member)"
          [profileColor]="member?.profileColor"
          [initials]="getInitials(member)"
        ></app-user-avatar>
        <div class="user-info">
          <span class="paragraph-medium font-medium name">{{ member?.full_name }}</span>
          <span class="paragraph-small-card font-light leaves"
            >{{ member?.leaves }} {{ 'myGanarbols.leaves' | translate }}</span
          >
        </div>
      </div>
      <div class="right-side flex">
        <div class="flex items-center gap-2 justify-center">
          <span class="text-sm md:text-base outfit font-normal">${{ member?.balance | thousandsSeparator }}</span>
          <div class="seperator font-normal"></div>
          <span class="text-sm md:text-base outfit font-normal"
            >${{ member?.total_earned_balance | thousandsSeparator }}</span
          >
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M13.9766 11.9986L9.85156 7.87365L11.0299 6.69531L16.3332 11.9986L11.0299 17.302L9.85156 16.1236L13.9766 11.9986Z"
            fill="#505760"
          />
        </svg>
      </div>
    </div>
  }
  <div class="flex flex-col justify-center items-center detail py-6 md:py-8">
    <p class="paragraph-medium text-center font-normal flex flex-col outfit">
      <span>{{ 'myGanarbols.showingCurrentEarnings' | translate }}</span>
      <span>{{ 'myGanarbols.GanaToUSD' | translate }}</span>
    </p>
  </div>
</div>
